
<template>
    <div class="center">
        <vs-dialog prevent-close v-model="active" @close="active = false">
            <template #header>
                <h4 class="not-margin">
                    Editar correo de familiar
                </h4>
            </template>
            <div class="con-form" ref="content">
                <vs-alert color="warn">
                    <template #title>
                        Advertencia
                    </template>
                        Al cambiar el correo, estará editando el correo de contacto, correo de recuperación de contraseña y el usuario del familiar.
                </vs-alert>
                <h6 class="mt-3"><strong>{{info.fullName}}</strong></h6>
                <label>Correo de acceso</label>
                <vs-input class="pt-0 pl-0" v-model="correo" placeholder="Correo">
                    <template #message-danger v-if="errorFields.includes('correo')">
                        Requerido
                    </template>
                </vs-input>
            </div>
            <template #footer>
                <div class="footer-dialog">
                        <vs-row>
                            <vs-col sm="6" lg="6">
                            <vs-button
                                danger
                                flat
                                @click="active = false">
                                Cancelar
                            </vs-button>
                            </vs-col>
                            <vs-col sm="6" lg="6">
                            <vs-button
                                success
                                class="ml-auto"
                                @click="postUpdateAccesoFamiliar()">
                                Guardar
                            </vs-button>
                            </vs-col>
                        </vs-row>
                </div>
            </template>
        </vs-dialog>
    </div>
</template>
<script>
import accesibilidad from '../../../../../api/requests/accesibilidad.js'
export default {
    props:[
      'value',
      'info',
      'filtros'
    ],
    data:() => ({
        active: false,
        correo: '',
        nombres: '',
        user_id: '',
        errorFields: []
    }),
    methods:{
        getInfo(){
            this.correo = this.info.acceso.email ? this.info.acceso.email : ''
            this.nombres = this.info.acceso.name ? this.info.acceso.name : ''
            this.user_id = this.info.acceso.id ? this.info.acceso.id : ''
        },
        sanityForm () {
            this.errorFields = []
            if (!this.correo) {
                this.errorFields.push('correo')
            }
            
            if (!this.errorFields.length){
                return true
            } else {
                return false
            }
        },
        async postUpdateAccesoFamiliar(){
            if(this.sanityForm() == true){
                const loading = this.$vs.loading()
                try{
                    const formData = new FormData()
                    formData.append('_method', 'PATCH')
                    formData.append('nombres', this.nombres)
                    formData.append('correo', this.correo)
                    formData.append('user_id', this.user_id)
                    formData.append('ciclo_escolar_id', this.filtros.cicloEscolar)
                    formData.append('institucion_id', this.filtros.institucion)
                    const response = await accesibilidad.postUpdateAccesoFamiliar(this.info.id, formData)
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa',
                        text: 'Se ha modificado el correo de acceso'
                    })
                    this.active = false
                    this.$emit('refreshTable')
                    loading.close()
                }catch{
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: null,
                        duration: 10000,
                        title: 'Se produjo un error',
                        text: 'Favor de comunicarse con el administrador'
                    })
                }
            }
        },
    },
    watch:{
        value (val) {
            this.active = val
        },
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        info(){
            this.getInfo()
        }
    }
}
</script>
